export class Solution {
  public id: string;
  public solutionId: string;
  public solutionSegmentId: string;
  public serviceOfferingId: string;

  public solutionName: string;
  public solutionSegmentName: string;
  public serviceOfferingName: string;

  public displayName: string;
  public displayCode: string;

  public isParent: boolean;
  public parentId: string; // this is id of its parent; a parent client should have parentId = 0

  constructor(
    id: string,
    solutionId: string,
    solutionSegmentId: string,
    serviceOfferingId: string,
    solutionName: string,
    solutionSegmentName: string,
    serviceOfferingName: string,
    displayName: string,
    displayCode: string,
    parentId: string,
    isParent: boolean,
  ) {
    this.id = id;
    this.solutionId = solutionId;
    this.solutionSegmentId = solutionSegmentId;
    this.serviceOfferingId = serviceOfferingId;
    this.solutionName = solutionName;
    this.solutionSegmentName = solutionSegmentName;
    this.serviceOfferingName = serviceOfferingName;
    this.displayName = displayName;
    this.displayCode = displayCode;
    this.parentId = parentId;
    this.isParent = isParent;
  }
}
